module.exports = __webpack_public_path__ + "img/xmAbs_icon.png";